import { FC } from "react";
import styles from "./Filters.module.css";
import { Radio, Space, RadioChangeEvent } from "antd";

import { useAppDispatch, useAppSelector } from "hooks";
import {
  clearLengthAndStatus,
  getLengthAndStatus,
  setLength,
  setStatus,
} from "store/ducks/filterHackathon/slice";

export const FilterBox: FC<{ title: string }> = ({ title, children }) => (
  <div className={styles.filterBox}>
    <div className={styles.title}>{title}</div>
    {children}
  </div>
);

const Filters: FC = () => {
  const dispatch = useAppDispatch();
  const { lengths, status } = useAppSelector(getLengthAndStatus);

  const handleLengthChange = (e: RadioChangeEvent) => {
    dispatch(setLength(e.target.value));
  };

  const handleStatusChange = (e: RadioChangeEvent) => {
    dispatch(setStatus(e.target.value));
  };

  const handleClear = () => {
    dispatch(clearLengthAndStatus());
  };

  return (
    <div className={styles.root}>
      {/* <div className="f-between">
        <div className="text-24 teko medium">Filters</div>
        <Button
          shape="round"
          size="small"
          className={styles.btnRemoveAll}
          type="text"
          onClick={handleClear}
        >
          Remove All Tags
        </Button>
      </div> */}

      <Space direction="vertical" size={12} className={styles.filterWrapper}>
        {/* <FilterBox title="Location">
          <Radio.Group defaultValue={1}>
            <Space direction="vertical" size={11}>
              <Radio className="text-16 medium" value={1}>
                Online
              </Radio>
              <Radio className="text-16 medium" value={2}>
                In Person
              </Radio>
            </Space>
          </Radio.Group>
        </FilterBox>

        <FilterBox title="Status">
          <Radio.Group value={status[0]} onChange={handleStatusChange}>
            <Space direction="vertical" size={11}>
              <Radio className="text-16 medium" value="Upcoming">
                Upcoming
              </Radio>
              <Radio className="text-16 medium" value="open">
                Open
              </Radio>
              <Radio className="text-16 medium" value="ended">
                Ended
              </Radio>
            </Space>
          </Radio.Group>
        </FilterBox> */}

        <FilterBox title="Length">
          <Radio.Group value={lengths[0]} onChange={handleLengthChange}>
            <Space direction="vertical" size={11}>
              <Radio className="text-16 medium" value="day">
                1 – 6 days
              </Radio>
              <Radio className="text-16 medium" value="week">
                1 – 4 weeks
              </Radio>
              <Radio className="text-16 medium" value="month">
                1+ month
              </Radio>
            </Space>
          </Radio.Group>
        </FilterBox>
      </Space>
    </div>
  );
};

export default Filters;
